import {
  conversationSchema,
  messageSchema,
  unreadMessageCountSchema,
  type Conversation,
  type ConversationListQuery,
  type Message,
  type MessageListQuery,
  type Page,
  type SendMessageInput,
  type StartConversationInput,
  type UnreadMessageCount,
} from '@teentack/shared';
import { apiFetch, post } from '@/lib/api-client';
import { fetchPage } from '@/lib/api-page';

/** Opens a thread, or returns the one that already exists for this pair. */
export async function startConversation(input: StartConversationInput): Promise<Conversation> {
  return conversationSchema.parse(await post<unknown>('/conversations', input));
}

export function fetchConversations(
  query: Partial<ConversationListQuery> = {},
): Promise<Page<Conversation>> {
  return fetchPage('/conversations', conversationSchema, query);
}

export async function fetchConversation(conversationId: string): Promise<Conversation> {
  return conversationSchema.parse(await apiFetch<unknown>(`/conversations/${conversationId}`));
}

export function fetchMessages(
  conversationId: string,
  query: Partial<MessageListQuery> = {},
): Promise<Page<Message>> {
  return fetchPage(`/conversations/${conversationId}/messages`, messageSchema, query);
}

export async function sendMessage(
  conversationId: string,
  input: SendMessageInput,
): Promise<Message> {
  return messageSchema.parse(
    await post<unknown>(`/conversations/${conversationId}/messages`, input),
  );
}

export async function markConversationRead(conversationId: string): Promise<{ updated: number }> {
  return post<{ updated: number }>(`/conversations/${conversationId}/read`, {});
}

/** A watching guardian steps into the thread, making it three-way. */
export async function joinConversation(conversationId: string): Promise<Conversation> {
  return conversationSchema.parse(
    await post<unknown>(`/conversations/${conversationId}/join`, {}),
  );
}

export async function fetchUnreadMessageCount(): Promise<UnreadMessageCount> {
  return unreadMessageCountSchema.parse(await apiFetch<unknown>('/conversations/unread-count'));
}
